import { render, staticRenderFns } from "./tab5.vue?vue&type=template&id=a4733478&scoped=true&"
import script from "./tab5.vue?vue&type=script&lang=js&"
export * from "./tab5.vue?vue&type=script&lang=js&"
import style0 from "./tab5.vue?vue&type=style&index=0&id=a4733478&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4733478",
  null
  
)

export default component.exports